import { useContext } from 'react'
import { ConfigProvider, MenuProps, Segmented } from 'antd'
import { AppContext } from "common/AppContext";
import { localStorageSetItem, localStorageGetItem, langKey } from "utils/localStorageHelper";
import { useIntl } from "react-intl"
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import classNames from "classnames";

export default function LangSelect({type}: {type: string}) {
  const intl = useIntl();

  const [checkedValue, setCheckedValue] = useState("zh-CN");
  const [isOpen, setIsOpen] = useState(false);

  const appContext = useContext(AppContext);

  const { setLocale } = appContext!;

  useEffect(() => {
    const lang = localStorageGetItem(langKey);

    if (lang != null && lang != "zh-CN") {
      changeLang(lang);
    }
  }, []);

  const changeLang = (value: string) => {
    setLocale(value);
    setCheckedValue(value);
    localStorageSetItem(langKey, value);
  }

  const items: MenuProps['items'] = [
    {
      key: "zh-CN",
      label: intl.formatMessage({ id: "common.lang.chinese.simplified" })
    },
    {
      key: "en-US",
      label: intl.formatMessage({ id: "common.lang.english" })
    }
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    setLocale(key);
    setCheckedValue(key);
    localStorageSetItem(langKey, key);
    setIsOpen(false);
  };

  if (type == "login") {
    return <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            colorBgElevated: "rgba(35, 35, 35, 0.5)",
            borderRadiusLG: 17.5,
            colorText: "rgb(207, 207, 207)",
            controlItemBgActive: "rgba(103, 100, 255, 0.4)",
            controlItemBgActiveHover: "rgba(103, 100, 255, 0.24)",
            controlItemBgHover: "rgba(103, 100, 255, 0.24)",
            colorPrimary: "rgb(207, 207, 207)",
          }
        },
      }}
    >
      <Dropdown menu={{ items, selectable: true, selectedKeys: [checkedValue], onClick }}
        trigger={['click']}
        placement="bottom"
        onOpenChange={(open) => { setIsOpen(open); }}
        className="select-lang" openClassName="select-lang" >
        <div className="tw-flex tw-justify-between tw-gap-3 tw-bg-transparent tw-px-[14px] tw-py-[12px] tw-text-[13.3px]">
          {checkedValue == "zh-CN" ? "简中" : intl.formatMessage({ id: "common.lang.english" })}
          <div className="tw-bg-transparent">{isOpen == false ? <DownOutlined /> : <UpOutlined />}</div>
        </div>
      </Dropdown>
    </ConfigProvider>
  }
  else {
    return <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            colorBgElevated: "rgb(235 243 255)",
            borderRadiusLG: 17.5,
            colorText: "rgb(7, 7, 7)",
            controlItemBgActive: "rgb(31, 145, 255,0.8)",
            controlItemBgActiveHover: "#1F91FF",
            controlItemBgHover: "#1F91FF",
            colorPrimary: "#fff",
          }
        },
      }}
    >
      <div className="tw-cursor-pointer">
      <Dropdown menu={{ items, selectable: true, selectedKeys: [checkedValue], onClick } }
        trigger={['click']}
        placement="bottom"
        onOpenChange={(open) => { setIsOpen(open); }}
        className="select-lang" openClassName="select-lang" >
        <div className="tw-flex tw-justify-between tw-gap-2 tw-bg-transparent tw-px-[14px] tw-leading-tight">
          {checkedValue == "zh-CN" ? "简中" : intl.formatMessage({ id: "common.lang.english" })}
          <div className="tw-bg-transparent">{isOpen == false ? <DownOutlined /> : <UpOutlined />}</div>
        </div>
      </Dropdown>
      </div>
    </ConfigProvider>
  }

  // return (<Segmented
  //   value={checkedValue}
  //   options={[{ label: (<div>中文</div>), value: "zh-CN" }, { label: (<div className="tw-tracking-normal">English</div>), value: "en-US" }]}
  //   onChange={value => { changeLang(value); }}
  // />);
}
